
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/audios/[slug]",
      function () {
        return require("private-next-pages/audios/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/audios/[slug]"])
      });
    }
  